import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal } from "flowbite-react";
import UserNavbar from "./userNavbar";
import UserFooter from "./userFooter";
import useGetEmail from "../hooks/GetEmail";
import secureLocalStorage from "react-secure-storage";
import AddBrouchureModal from "./AddBrouchure";
import VieWDataModal from "./viewDataModal";
import { tableDataContext } from "../dashboard/context/productData";
import useGetVendorData from "../hooks/GetVendors";
import GridSection from "./GridSection";
import HistoryModal from "./historyModal";

const Account = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [holdData, setHoldData] = useState([]);
  const [ven_name, setVen_name] = useState();
  const [date, setDate] = useState();
  const [favorites, setFavorites] = useState([]);
  const [selectedTab, setSelectedTab] = useState("allProduct");
  const [holdDataFilters, setHoldDataFilters] = useState([]);
  const [adminFiltered, setAdminFiltered] = useState([]);
  const [savedSoFar, setSavedSoFar] = useState();
  const [error, setError] = useState({});
  const [selected, setSelected] = useState();
  const [loaderModal, setLoaderModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [viewHistory, setViewHistory] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const [show, setShow] = useState(false);
  const { email } = useGetEmail();
  const { data } = useGetVendorData();
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    setFullData,
    selectedFilters,
    setFilters,
    filters,
    setSelectedFilters,
    selectedVendor,
  } = useContext(tableDataContext);

  useEffect(() => {
    handleSaveHistory();
    handleFavorites();
    setSelectedFilters([]);
  }, []);

  useEffect(() => {
    selectedSearch();
  }, [selectedFilters]);

  useEffect(() => {
    handleTabData();
  }, [selectedTab]);

  const handleTabData = () => {
    if (selectedTab === "allProduct") {
      handleAllData();
    } else if (selectedTab === "myChains") {
      handleMyChains();
    } else if (selectedTab === "favorites") {
      handleFavorites();
    }
  };

  const selectedSearch = (e) => {
    if (selectedFilters.length === 0) {
      if (selectedTab === "allProduct") {
        handleAllData();
      } else if (selectedTab === "myChains") {
        handleMyChains();
      } else if (selectedTab === "favorites") {
        handleFavorites();
      }
    } else if (selectedTab === "favorites") {
      const filteredResults = holdDataFilters.filter((product) => {
        return selectedFilters.some((filter) => {
          return product.productName
            .toLowerCase()
            .includes(filter.toLowerCase());
        });
      });
      setHoldData(filteredResults);
    } else {
      if (selectedVendor && selectedVendor != "default") {
        const filteredData = adminFiltered.filter(
          (item) => item.vendorName === selectedVendor
        );
        const filteredResults = filteredData.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      } else {
        const filteredResults = adminFiltered.filter((product) => {
          return selectedFilters.some((filter) => {
            return product.productName
              .toLowerCase()
              .includes(filter.toLowerCase());
          });
        });
        setFullData(filteredResults);
      }
    }
  };

  const handleAllData = () => {
    setFullData([]);
    setLoader(true);

    axios
      .get(`${process.env.REACT_APP_API}/non_expired_products`)
      .then((res) => {
        handleParseData(res.data.non_expired_products);
      })
      .catch((err) => {
        setLoader(false);
        console.error(err);
      });
  };

  const handleParseData = (res) => {
    // Build a map of expire_date by pdf_name, vendor_name, user_identifier
    const expireDateMap = {};
    res.forEach(item => {
      if (item.expire_date) {
        const key = `${item.pdf_name}_${item.vendor_name}_${item.user_identifier}`;
        expireDateMap[key] = item.expire_date;
      }
    });
    const data = res.filter((p) => p.output);
    const structuredData = data.flatMap((item) => {
      try {
        const products = JSON.parse(item.output.output);
        return products.map((product) => {
          const key = `${item.pdf_name}_${item.vendor_name}_${item.user_identifier}`;
          return {
            productName: product["Product Name"] || "",
            oldPrice: product["Old Price"] || "",
            currentPrice: product["Current Price"] || "",
            quantity: product["Quantity"] || "",
            discount: product["Discount"] || "",
            pdfName: item.pdf_name || "",
            vendorName: item.vendor_name || "",
            // expire_date: expireDateMap[key] || "Not Available",
            expire_date: item.expiry_date || "Not Available",
          };
        });
      } catch (error) {
        setLoader(false);
        console.error(
          `Error parsing JSON for item with pdf_name: ${item.pdf_name}`,
          error
        );
        return [];
      }
    });
    if (selectedVendor && selectedVendor != "default") {
      const filteredResults = structuredData.filter(
        (item) => item.vendorName === selectedVendor
      );
      setFullData(filteredResults);
    } else {
      setFullData(structuredData);
    }
    setAdminFiltered(structuredData);
    setLoader(false);
  };

  const handleFavorites = () => {
    setHoldData([]);
    axios
      .get(
        `https://aipricingtool-python.onrender.com/get_data_by_user_identifier/${id}`
      )
      .then((resp) => {
        if (resp.data.message) {
          setFavorites([]);
          setHoldData([]);
          setHoldDataFilters([]);
          return;
        }
        const data = resp.data.map((product) => ({
          _id: product._id,
          productName: product.product_name,
          oldPrice: product.old_price || "",
          currentPrice: product.current_price || "",
          quantity: product.quantity || "",
          discount: product.discount || "",
          pdfName: product.pdf_name || "",
          vendorName: product.vendor_name || "",
        }));
        setHoldData(data);
        setHoldDataFilters(data);

        const savedSoFar = data.map((product) => {
          return product?.discount
            ? product.oldPrice - product.currentPrice
            : 0;
        });
        const saving = savedSoFar.reduce((acc, curr) => acc + curr, 0);

        setSavedSoFar(saving);

        const favorites = resp.data.map(
          (product) => `${product.product_name}-${product.vendor_name}`
        );

        setFavorites(favorites);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleMyChains = () => {
    setFullData([]);
    setLoader(true);
    axios
      .get(`https://aipricingtool-python.onrender.com/check_user_data/${id}`)
      .then((resp) => {
        handleParseData(resp.data);
      })
      .catch((err) => {
        setLoader(false);
        console.error(err);
      });
  };
  const handleSaveHistory = async () => {
    try {
      axios
        .post("https://aipricingtool-python.onrender.com/get_saved_products", {
          user_identifier: id,
        })
        .then((response) => {
          setFilters(response.data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const handleViewHistory = () => {
    setSpinner(true);
    axios
      .get("https://aipricingtool-python.onrender.com/get_logs", {
        params: { user_identifier: id },
      })
      .then((response) => {
        console.log(response.data);
        setLogsData(response.data.logs);
        setViewHistory(true);
        setSpinner(false);
      })
      .catch((error) => {
        console.error(error);
        setSpinner(false);
        if (error.response?.status === 500) {
          toast.error("Server error: Unable to load history. Please try again later.");
        } else if (error.response?.data?.detail) {
          toast.error(`Error: ${error.response.data.detail}`);
        } else {
          toast.error("Failed to load history. Please try again.");
        }
      });
  };

  const handleUploadpdf = async () => {
    setOpenModal(false);
    setLoaderModal(true);
    setSpinner(true);
    const formData = new FormData();
    formData.append("file", selectedFileName);
    formData.append("vendor_name", ven_name);
    formData.append("user_id", id);
    formData.append("expire_date", date);
    console.log(formData);

    try {
      const uploadResponse = await axios.post(
        "https://aipricingtool-python.onrender.com/upload",
        formData
      );

      if (uploadResponse.data.images) {
        await toast.promise(
          () => {
            setLoaderModal(false);
            setSpinner(false);
            return axios
              .post("https://aipricingtool-python.onrender.com/gemini", {
                vendor_name: ven_name,
                pdf_name: uploadResponse.data.pdf_name,
                user_identifier: id,
                expire_date:date,
                socket_id: id,
               
              })
              .then((geminiResponse) => {
                // Logs API based on Gemini response
                return axios
                  .post("https://aipricingtool-python.onrender.com/show_logs", {
                    pdf_name: uploadResponse.data.pdf_name,
                    vendor_name: ven_name,
                    user_identifier: id,
                    status: geminiResponse.data.every(
                      (response) => response.output
                    )
                      ? "successfull"
                      : "failed",
                  })
                  .then(() => {
                    console.log("Logs saved successfully");
                  })
                  .catch(() => {
                    console.log("Error saving logs");
                  });
              });
          },
          {
            pending: "Brochure is uploading. Please Wait...",
            error: "There was an error uploading Brochure",
            success: "Brochure uploaded successfully",
          }
        );
      } else {
        setLoaderModal(false);
        setSpinner(false);
      }

      if (uploadResponse.data.success) {
        setLoaderModal(false);
        setShow(true);
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("An error occurred during the upload process.");

      // Optional: Log errors related to the upload API if required
    } finally {
      setSpinner(false);
      setLoaderModal(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    secureLocalStorage.clear();
    axios
      .post("https://aipricingtool-python.onrender.com/Signout", {
        email: email.useremail,
      })
      .then((res) => {
        toast.success("Sign Out Successful");
        navigate("/signin");
      })
      .catch((err) => {
        console.error("error Signing out", err);
        toast.error("SignOut Failed!!");
      });
  };

  const handleDeleteHistory = () => {
    if (filters.length > 0) {
      axios
        .post("https://aipricingtool-python.onrender.com/delete_history", {
          user_identifier: id,
        })
        .then((res) => {
          toast.success(res.data.message);
          setSelectedFilters([]);
          setFilters([]);
          handleTabData();
        })
        .catch((err) => {
          console.error(err.response.data.error);
          toast.error(err.response.data.error);
        });
    }
  };

  return (
    <>
      <UserNavbar />

      <div className="font-userFont flex-1 pb-6 mt-16 mb-16 ">
        <div className="flex flex-col justify-center items-center w-full  mx-auto space-y-8">
          <h1 className="text-6xl ">User Settings</h1>
          <h1>
            Saved Vendors:
            <span className="font-bold">
              {data ? data.join(", ") : "No Vendor name Found"}
            </span>
          </h1>
          <h1>
            Saved so far: <span>{savedSoFar ? savedSoFar : 0} BGN </span>
          </h1>
          <div className="flex space-x-8">
            <button
              type="button"
              className="bg-[#E3D0A8] px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] "
              onClick={() => handleLogout()}
            >
              Log Out
            </button>
            <button
              type="button"
              className="bg-[#E3D0A8] px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] "
              onClick={() => handleViewHistory()}
            >
              View History
            </button>
            <button
              type="button"
              className="bg-[#E3D0A8] px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8]"
              onClick={() => {
                setSelectedFileName("");
                setVen_name("");
                setOpenModal(true);
              }}
            >
              Add Brochure
            </button>
          </div>
        </div>

        {/* Tabs Section */}
        <GridSection
          handleSaveHistory={handleSaveHistory}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          favorites={favorites}
          handleDeleteHistory={handleDeleteHistory}
          holdData={holdData}
          handleFavorites={handleFavorites}
          loader={loader}
          vendorData={adminFiltered}
        />
      </div>
      <AddBrouchureModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        selectedFileName={selectedFileName}
        setSelectedFileName={setSelectedFileName}
        ven_name={ven_name}
        setVen_name={setVen_name}
        date={date}
        setDate={setDate}
        error={error}
        setError={setError}
        handleUploadpdf={handleUploadpdf}
      />
      <HistoryModal
        openModal={viewHistory}
        setOpenModal={setViewHistory}
        logsData={logsData}
      />

      {/* Loader modal */}
      <Modal
        show={loaderModal}
        size="md"
        className="dashboard-modal-main ring-0 bg-opacity-60"
        // onClose={() => setOpenModal(false)}
        popup
      >
        <Modal.Body className="bg-white rounded-[25px] p-5 ">
          <div className="text-center flex justify-center items-center flex-col gap-3">
            {spinner ? (
              <>
                <div className="spinner1"></div>
                <h3 className="analyzing mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                  Analyzing Document...
                </h3>
              </>
            ) : (
              <></>
            )}

            {/* <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" /> */}
          </div>
        </Modal.Body>
      </Modal>
      <VieWDataModal selectedData={selected} />
      <UserFooter />
    </>
  );
};

export default Account;
